import { Component, Input, OnInit } from '@angular/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { select, Store } from '@ngrx/store';
import {
  actionCountriesListGet,
  countriesList,
  PrimaryAddress,
} from 'src/app/core';

@UntilDestroy()
@Component({
  selector: 'app-format-address',
  templateUrl: './format-address.component.html',
  styleUrls: ['./format-address.component.less'],
})
export class FormatAddressComponent implements OnInit {
  _countryCode: string;
  _address: PrimaryAddress;
  country: string;
  inlineAddress: string;

  @Input() displayInline: boolean;
  @Input() displayIcon: boolean;
  @Input() enableCopy: boolean;

  @Input() set countryCode(value: string) {
    this._countryCode = value;
    this._getCountry();
  }
  get countryCode() {
    return this._countryCode;
  }

  @Input() set address(value: PrimaryAddress) {
    this._address = value;
  }
  get address() {
    return this._address;
  }
  constructor(private store: Store) {}

  ngOnInit(): void {
    this.store.dispatch(actionCountriesListGet());
    this._getCountry();
  }

  private _getCountry() {
    if (this.countryCode) {
      this.store
        .pipe(select(countriesList), untilDestroyed(this))
        .subscribe((countriesList) => {
          if (countriesList) {
            let countryInfo = Object.entries(countriesList).filter(
              (entry) => entry[0] === this.countryCode
            )[0];
            if (countryInfo) {
              this.country = countryInfo[1];
            }
          }
        });
    }
  }

  setInlineAddress(address) {
    this.inlineAddress = address;
  }
}
